import { PANEL_KEYS } from '@bingads-webui-campaign-react/wizard-shared-components';

export const STEP_PATHS = {
  PRODUCTS: 'PRODUCTS',
  ASSETS: 'ASSETS',
  TARGETING: 'TARGETING',
  CAMPAIGNDETAILS: 'CAMPAIGNDETAILS',
  BUDGET: 'BUDGET',
  SUMMARY: 'SUMMARY',
  CAMPAIGNSETTING: 'CAMPAIGNSETTING',
  ASSETGROUPSETTING: 'ASSETGROUPSETTING',
};

export const FLOWS = {
  PERFMAX_WIZARD: 'PERFMAX_WIZARD',
  RETAIL_PERF_MAX: 'RETAIL_PERF_MAX',
};

export const FLOWS_TO_FIRST_STEP = {
  [FLOWS.PERFMAX_WIZARD]: STEP_PATHS.ASSETS,
  [FLOWS.RETAIL_PERF_MAX]: STEP_PATHS.PRODUCTS,
};

export const getFlow = ({ flow }) => {
  if (flow === FLOWS.RETAIL_PERF_MAX) {
    const steps = [
      STEP_PATHS.PRODUCTS,
      STEP_PATHS.ASSETS,
      STEP_PATHS.TARGETING,
      STEP_PATHS.CAMPAIGNDETAILS,
      STEP_PATHS.BUDGET,
      STEP_PATHS.SUMMARY,
    ];

    return steps;
  }

  const steps = [
    STEP_PATHS.ASSETS,
    STEP_PATHS.TARGETING,
    STEP_PATHS.CAMPAIGNDETAILS,
    STEP_PATHS.BUDGET,
    STEP_PATHS.SUMMARY,
  ];

  return steps;
};

export const getAssetsPanels = (permissions) => {
  const panels = ['final-url', 'images', 'logos', 'headlines', 'long-headlines', 'descriptions', 'business-name', 'call-to-action'];

  if (permissions.dynamic.PMaxVideo && permissions.dynamic.PmaxNorthStarAssetGroupSetting) {
    panels.push('videos');
  }

  return panels;
};

export const getCampaignSettingsPanels = (permissions, isCampaignShoppingType) => {
  const {
    PerformanceMaxCampaignsAutoGenAssetControl: IsPerformanceMaxCampaignsAutoGenAssetControlEnabled,
    PerformanceMaxCampaignsPageFeeds: IsPerformanceMaxCampaignsPageFeedsEnabled,
    BrandExclusion: IsBrandExclusionEnabled,
    PerformanceMaxInCnMarket: IsPerformanceMaxInCnMarketEnabled,
    NewCustomerAcquisition: IsNewCustomerAcquisitionEnabled,
    PMaxDisclaimers,
    PMaxBrandShowroom,
  } = permissions.dynamic;

  const {
    IsDomesticSimplifiedChineseEnabled,
    IsMSANDisclaimerEnabled,
  } = permissions;

  const isFeatureBlockedForCnMarket = IsDomesticSimplifiedChineseEnabled && IsPerformanceMaxInCnMarketEnabled;
  const isPMaxDisclaimersEnabled = !IsDomesticSimplifiedChineseEnabled && PMaxDisclaimers && IsMSANDisclaimerEnabled;

  const advancedPanels = [
    PANEL_KEYS.AD_SCHEDULE,
    PANEL_KEYS.URL_OPTIONS,
  ];


  if (!IsPerformanceMaxCampaignsAutoGenAssetControlEnabled && !isFeatureBlockedForCnMarket) {
    advancedPanels.push(PANEL_KEYS.FINAL_URL_EXPANSION);
  }

  if (IsPerformanceMaxCampaignsAutoGenAssetControlEnabled && !isFeatureBlockedForCnMarket) {
    advancedPanels.push(PANEL_KEYS.AUTO_GEN_ASSETS);
  }

  if (IsPerformanceMaxCampaignsPageFeedsEnabled) {
    advancedPanels.push(PANEL_KEYS.PAGE_FEEDS);
  }

  if (IsBrandExclusionEnabled) {
    advancedPanels.push(PANEL_KEYS.BRAND_EXCLUSIONS);
  }

  if (isPMaxDisclaimersEnabled && !isCampaignShoppingType) {
    advancedPanels.push(PANEL_KEYS.DISCLAIMERS);
  }

  const basicPanels = [
    PANEL_KEYS.BID_STRATEGY,
    PANEL_KEYS.BUDGET,
    PANEL_KEYS.LOCATIONS,
    PANEL_KEYS.LANGUAGE_TARGET,
    PANEL_KEYS.AD_SCHEDULE,
    PANEL_KEYS.URL_OPTIONS,
    PANEL_KEYS.SHOPPING,
    PANEL_KEYS.CONVERSIONS,
  ];

  if (IsNewCustomerAcquisitionEnabled) {
    basicPanels.push(PANEL_KEYS.NEW_CUSTOMER_ACQUISITION);
  }

  if (PMaxBrandShowroom) {
    advancedPanels.push(PANEL_KEYS.BRAND_SHOWROOM);
  }

  return {
    basicPanels,
    advancedPanels,
  };
};


export const getCampaignDetailsPanels = (permissions, isCampaignShoppingType) => {
  const {
    PerformanceMaxCampaignsAutoGenAssetControl: IsPerformanceMaxCampaignsAutoGenAssetControlEnabled,
    PerformanceMaxCampaignsPageFeeds: IsPerformanceMaxCampaignsPageFeedsEnabled,
    BrandExclusion: IsBrandExclusionEnabled,
    PerformanceMaxInCnMarket: IsPerformanceMaxInCnMarketEnabled,
    PMaxDisclaimers,
    PMaxBrandShowroom,
  } = permissions.dynamic;

  const {
    IsDomesticSimplifiedChineseEnabled,
    IsMSANDisclaimerEnabled,
  } = permissions;

  const isFeatureBlockedForCnMarket = IsDomesticSimplifiedChineseEnabled && IsPerformanceMaxInCnMarketEnabled;
  const isPMaxDisclaimersEnabled = !IsDomesticSimplifiedChineseEnabled && PMaxDisclaimers && IsMSANDisclaimerEnabled;

  const advancedPanels = [
    PANEL_KEYS.AD_SCHEDULE,
    PANEL_KEYS.CAMPAIGN_URL_OPTIONS,
  ];

  if (!IsPerformanceMaxCampaignsAutoGenAssetControlEnabled && !isFeatureBlockedForCnMarket) {
    advancedPanels.push(PANEL_KEYS.FINAL_URL_EXPANSION);
  }

  if (IsPerformanceMaxCampaignsAutoGenAssetControlEnabled && !isFeatureBlockedForCnMarket) {
    advancedPanels.push(PANEL_KEYS.AUTO_GEN_ASSETS);
  }

  if (IsPerformanceMaxCampaignsPageFeedsEnabled) {
    advancedPanels.push(PANEL_KEYS.PAGE_FEEDS);
  }

  if (IsBrandExclusionEnabled) {
    advancedPanels.push(PANEL_KEYS.BRAND_EXCLUSIONS);
  }

  if (isPMaxDisclaimersEnabled && !isCampaignShoppingType) {
    advancedPanels.push(PANEL_KEYS.DISCLAIMERS);
  }

  if (PMaxBrandShowroom) {
    advancedPanels.push(PANEL_KEYS.BRAND_SHOWROOM);
  }

  return {
    advancedPanels,
  };
};
